let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("hmR49")]).then(() => parcelRequire('7gC3k'));